export default {
  title: {
    id: 'product_checkpoints_carousel_title',
    defaultMessage:
      'All devices are restored professionally based on a 25-point inspection',
  },
  subtitleDynamic: {
    id: 'product_checkpoints_carousel_title_by_number',
    defaultMessage:
      'All devices are restored professionally based on a {nb_points}-point inspection',
  },
}
